import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { IntegrationsComponent } from './integrations.component';

@NgModule({
  declarations: [
    IntegrationsComponent
  ],
  imports: [
    CommonModule,
    RouterModule
  ]
})
export class IntegrationsModule { }
